import React from 'react';
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom';

const TrialHistory = (props) => {
	const { trials } = props;

	return (
		<Col>
			<div className="tab-rt-extend">
				<div className="tab-title">Trial History</div>
				<div className="line-blk-shrink2" />
				<table className="table">
					<tbody className="">
						{trials.map((item) => (
							<tr key={item.id}>
								<td className="trial-status">
									{item.active === true ? (
										<img src="/images/icon-active.jpg" alt="" />
									) : (
										<img src="/images/icon-inactive.jpg" alt="" />
									)}
								</td>
								<td className="file-details trials">
									<Link
										to={`/trial/${item.id}/organization/trial-summary`}
										key={item.id}
										value={item.name}
									>
										<ul className="">
											<li>{item.name}</li>
											<li className="subtitle-tiny-grey">
												{item.institution}
												<img src="/images/icon-arrow.jpg" className="angle2" alt="" />
											</li>
											<li className="subtitle-tiny-ltGrey">
												CREATED: {item.createdDate}
												<span />
											</li>
										</ul>
									</Link>
								</td>
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</Col>
	);
};

export default TrialHistory;
